import React, { useEffect, useState, useMemo } from "react";
import ReactSelect from "react-select";
import { useStateContext } from "../../../../../../Context/StateContext";

export default function SubcategoryOptionForPosts({ values,filter, keywords }) {
  const [allSkills, setAllSkills] = useState([]);
  const [selectSkills, setSelectSkills] = useState(null);

  const { state, setSubcategories } = useStateContext();
  const { subcategories } = state;

  // store everything that comes in
  useEffect(() => {
    if (Array.isArray(values)) {
      setAllSkills(values);
    }
  }, [values]);

  // collect parent category ids from keywords
  const categoryIds = useMemo(
    () => (Array.isArray(keywords) ? keywords.map((k) => k.id) : []),
    [keywords]
  );

  // filter allSkills based on the selected category ids
  const filteredSubcategories = useMemo(() => {
    if (!Array.isArray(allSkills) || categoryIds.length === 0) return [];
    return allSkills.filter((item) => categoryIds.includes(item.parent_id));
  }, [allSkills, categoryIds]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = { id: selectedOption.value, title: selectedOption.label };
    setSubcategories([...(subcategories || []), newLanguage]);
    setSelectSkills(null); // clear dropdown after select
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = (subcategories || []).filter((language) => language.id !== id);
    setSubcategories(updatedLanguages);
  };

  return (
    <div>
      <ReactSelect
        options={filteredSubcategories
          .filter((lang) => !(subcategories || []).some((sel) => sel.id === lang.id))
          .map((lang) => ({ value: lang.id, label: lang.title }))}
        placeholder={`Select ${filter?.title || ""}`}
        isClearable
        value={selectSkills}
        onChange={(option) => option && handleLanguageChange(option)}
      />

      <div className="add-skills">
        {(subcategories || []).map((skills) => (
          <div key={skills.id}>
            <p onClick={() => handleDeleteLanguage(skills.id)}>
              {skills.title} <span>x</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
